import { sortData } from "lib/util/sort";

export function sortTable(data, setDataList, sortedColumns, setSortedColumns, setExpandedRowIndex) {
  setExpandedRowIndex(null);
  let sorted = sortData(data, sortedColumns);
  setDataList(sorted);
  setSortedColumns(sortedColumns);
}
